import { __assign, __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useMemo } from "react";
import { ButtonArea, RadioLabel } from "./styles";
import { generateColorVariants } from "../../utils/functions";
export var Radio = forwardRef(function Radio(_a, ref) {
    var label = _a.label, _b = _a.labelPosition, labelPosition = _b === void 0 ? "right" : _b, customColor = _a.customColor, register = _a.register, props = __rest(_a, ["label", "labelPosition", "customColor", "register"]);
    var colorVariants = customColor
        ? useMemo(function () { return generateColorVariants(customColor); }, [customColor])
        : undefined;
    return (_jsxs(RadioLabel, { "$labelPosition": labelPosition, children: [label && _jsx("span", { children: label }), _jsx("input", __assign({ ref: ref, type: "radio" }, register, props)), _jsx(ButtonArea, { colorVariants: colorVariants })] }));
});
//# sourceMappingURL=index.js.map